import api from "../utils/axios";

export async function validatePurchase({
    productId,
    variationId,
    quantity = 1,
    giftId = null,
}) {
    const response = await api.get(
        `/products/${productId}/purchase`,
        {
            params: {
                variation_id: variationId,
                quantity,
                gift_id: giftId,
            },
        }
    );

    return response.data.data;
}